export const messageTemplates = {

"Welcome Message": [
    `Bonjour {title} {name},

Je vous remercie de votre demande de services de bartending sur {platform} et pour avoir considéré Flair Flow pour votre {eventType}.

Nous sommes disponibles pour réaliser votre événement du {date} et nous avons l’expérience nécessaire pour créer des boissons uniques et une ambiance et show mémorable pour vos invités.

Pour connaître nos formules et recevoir un devis personnalisé, n’hésitez pas à nous contacter par téléphone au 0184802905. Nous serions ravis de discuter de votre projet en détail et de vous aider à organiser un événement réussi et inoubliable.

Vous pouvez également utiliser notre planificateur pour obtenir une fourchette de prix et réserver un rendez-vous téléphonique en suivant ce lien : https://flair-flow.involve.me/planner 

Cordialement,

Filippo C.
Flair Flow
0184802905
www.flairflow.com
IG: @flairflowofficial
`
    
],
"Full Booked": [
    `Bonjour {title} {name},

Je vous remercie de votre demande de services de bartending sur {platform} et de votre intérêt pour Flair Flow à l'occasion de votre {eventType}.
Je regrette de vous informer que malheureusement pour la date {date}  que vous avez mentionnée, nous sommes déjà au complet. En raison de la forte demande pour nos services, nous conseillons généralement à nos clients de réserver au moins 2 à 3 mois à l'avance pour garantir la disponibilité.

Pour connaître nos formules et recevoir un devis personnalisé, n’hésitez pas à me contacter par téléphone au 0184802905. Je serai ravi de discuter de vos projets en détail et de vous aider à organiser des événements réussis et inoubliables.

Vous pouvez également réserver un rendez-vous téléphonique sur mon agenda Calendly en suivant ce lien : https://calendly.com/flairflowofficial/questionnaire-devis

Cordialement,

Filippo C.
Flair Flow
0184802905
www.flairflow.com
IG : @flairflowofficial
`

],
"Relance Accompte 1": [
    `Bonjour {title} {name},

J'espère que vous allez bien. Je reviens vers vous pour savoir si vous avez des questions concernant notre solution pour votre {eventType}.

Je tiens à vous rappeler que nous pouvons garantir un service impeccable et inoubliable afin que vous puissiez profiter pleinement de cette expérience.

En raison de la forte demande pour nos services de bartending, nous vous encourageons à revenir vers nous au plus vite afin de vous garantir la disponibilité pour votre évènement.

N'hésitez pas à me contacter pour toutes questions.

Belle journée à vous et à bientôt.

Cordialement,

Filippo
Flair Flow
`
],
"Relance Accompte 2": [
    `Bonjour {title} {name},

J'espère que vous allez bien. Suite à mon précédent mail concernant nos services de bartending pour votre événement, je n'ai pas encore reçu de réponse de votre part. Peut-être que le mail est passé inaperçu ou que vous êtes submergé par d'autres tâches.

Je tenais simplement à m'assurer que vous aviez toutes les informations nécessaires et que vous n'aviez aucune interrogation en suspens. 


Si vous avez besoin d'un délai supplémentaire ou de précisions, je reste à votre entière disposition.

Je vous souhaite une excellente journée 

Bien à vous,

Filippo
Flair Flow
`
],
"Négociation Accepted": [
    `Bonjour {title} {name},

J'espère que vous allez bien. Merci de votre retour, nous sommes ravis et nous avons hâte de vous servir et de vous accompagner pendant cette occasion spéciale.

Pour finaliser la réservation, je vous invite à nous retourner le devis signé par email et à procéder au virement de l'acompte. Vous trouverez les coordonnées bancaires directement sur le devis.

Dès réception du virement, je vous adresserai la facture correspondant à l'acompte ainsi que la confirmation officielle de votre réservation.

Pour toute question ou précision, je reste bien sûr à votre disposition.

N'hésitez pas à me contacter si besoin.

Belle journée à vous et à bientôt.


Cordialement,

Filippo
Flair Flow
`
],
"Négociation Not Accepted": [
    `Bonjour {title} {name},

J'espère que vous allez bien. Merci pour votre retour,je comprends tout à fait. je suis navré que notre offre n'ait pas répondu entièrement à vos attentes.

Je reste à votre disposition pour discuter d'une nouvelle proposition ou pour répondre à toute autre demande. 

Je vous souhaite une belle journée et j'espère à très bientôt.

Cordialement,

Filippo
Flair Flow
`
],
"Facture Accompte": [
    `Bonjour {title} {name},

J'espère que vous allez bien Je vous envoi en PJ la Facture d’acompte {regler} par {paymentType}. 

Je tenais encore à vous remercier pour votre confiance.

Je reste disponible, n'hésitez pas à me contacter pour toutes questions.

Belle journée à vous et à bientôt

Filippo
Flair Flow
`
],
"Logistique": [
    `Bonjour {title} {name},

J'espère que vous allez bien je reviens vers vous pour revoir les détails pour l'événement du {date}. 


Afin de peaufiner les préparatifs pour l'événement ,Je vous invite à prendre rdv directement en ligne sur mon agenda : https://calendly.com/flairflowofficial/details-logistique

Après avoir vu ensemble tous les détails sur les lieux , ainsi que les choix des cocktails je vous enverrai le graphisme à vérifier et confirmer et la liste de matériels et mobilier à fournir (si nécessaire) .

Je reste disponible

Belle journée à vous et à bientôt

Filippo
Flair Flow
`
],
"Thanks Service": [
    `Bonjour {title} {name},

J'espère que vous allez bien. Je me permets de vous contacter pour obtenir un retour sur la prestation du {Date}. J'espère que tout s'est déroulé comme prévu et que vos invités ont apprécié les cocktails ainsi que notre service.

Je tenais encore à vous remercier pour votre gentillesse et merci encore de nous avoir accordé votre confiance. C'était un véritable plaisir de collaborer avec vous.

Voici le lien de la plateforme si vous souhaitez laisser un commentaire pour la prestation 

Laissez nous un Avis : 

Star of service:
www.starofservice.com/service/evaluer/a4bbe42b-5425-b858-d93b-a87cc00e643f

Google:
https://g.page/r/CTidKDVK7S6-EAI/review

Je reste à votre disposition, n'hésitez pas à me contacter si besoin.

Je vous souhaite une excellente journée et espère à très bientôt!

Cordialement,
Filippo
`
],
"Thanks + Payment": [
    `Bonjour {title} {name},

J'espère que vous allez bien. Je me permets de vous contacter pour obtenir un retour sur la prestation du {date}.
J'espère que tout s'est déroulé comme prévu et que vos invités ont apprécié les cocktails ainsi que notre service.

Je vous envoi en PJ la Facture de Solde {regler} par {paymentType}. 

Je tenais encore à vous remercier pour votre gentillesse et merci encore de nous avoir accordé votre confiance. C'était un véritable plaisir de collaborer avec vous.

Voici le lien de la plateforme si vous souhaitez laisser un commentaire pour la prestation 

Laissez nous un Avis : 

Star of service:
www.starofservice.com/service/evaluer/a4bbe42b-5425-b858-d93b-a87cc00e643f

Google:
https://g.page/r/CTidKDVK7S6-EAI/review

Je reste à votre disposition, n'hésitez pas à me contacter si besoin.

Je vous souhaite une excellente journée et espère à très bientôt!

Cordialement,
Filippo
`
],
"Relance Payment 1": [
    `Bonjour {name},

J'espère que vous allez bien. Je me permets de vous contacter puisque nous n’avons pas reçu le virement de la prestation de solde du {date}.

Pourriez vous vérifier si le virement a bien été pris en charge?

Merci d' avance pour votre retour, je reste à votre disposition, n'hésitez pas à me contacter si besoin.

Je vous souhaite une excellente journée et à bientôt!

Cordialement,

Filippo
`
],
"Relance Payment 2": [
    `Bonjour {name},

J'espère que vous allez bien. Je me permets de vous recontacter puisque nous n’avons pas reçu le virement de la prestation de solde du {date}.

Merci de vérifier le virement à été bien effectué 

Je vous souhaite une excellente journée et à bientôt!

Cordialement,

Filippo
`
],
};